export default "__VITE_ASSET__BQINcPO1__"